<template>
  <div>
    <top-bar heading="Evidence Gallery"></top-bar>
    <div class="container-fluid mt-3">
      <b-card class="p-3">
        <div class="row">
          <div class="col-12 text-center">
            <h4>Welcome to the Evidence Gallery</h4>
            <p>The Evidence Gallery allows you to take and upload photos of work undertaken on the job to use as evidence required as part of your Training Plan</p>
            <p>Evidence can be stored and used at a later date, on current and future modules. You can also browse submitted evidence via the course name it was submitted to.</p>
          </div>
          <div class="col-12 col-md-6">
            <button class="btn btn-block btn-orange pt-3 pb-3" @click="mode = 1">
              <font-awesome-icon icon="camera"></font-awesome-icon>
              Add New Evidence
            </button>
          </div>
          <div class="col-12 col-md-6">
            <button class="btn btn-block btn-lime pt-3 pb-3" @click="mode = 2">
              <font-awesome-icon icon="images"></font-awesome-icon>
              Browse Evidence Gallery
            </button>
          </div>
        </div>
      </b-card>
      <evidence-gallery-submit v-show="mode === 1"></evidence-gallery-submit>
      <evidence-gallery-browse v-show="mode === 2"></evidence-gallery-browse>
    </div>
  </div>
</template>

<script>
import EvidenceGallerySubmit from '../../components/EvidenceGallery/Submit';
import EvidenceGalleryBrowse from '../../components/EvidenceGallery/Browse';
export default {
  name: 'EvidenceGallery',
  components: {EvidenceGalleryBrowse, EvidenceGallerySubmit},
  metaInfo: {
    title: 'Evidence Gallery'
  },
  data() {return {
    mode: 0
  }}
};
</script>
